var mixer;
var container = document.querySelector('.filter-list');

if (container) {
    var selectFilter = document.querySelector('#select-filter');

    var mixer = mixitup(container, {
        selectors: {
            target: '.filter-list__item'
        },
        animation: {
            duration: 200,
            nudge: true,
            reverseOut: false,
        },
        callbacks: {
        }
    });

    selectFilter.addEventListener('change', function() {
        var selector = selectFilter.value;
    
        mixer.filter(selector);
    });
}
